<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <card>
        <div
          class="col-md-12 col-lg-12 col-sm-12"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <div class="modal-body">
            <div>
              <h4
                slot="header"
                id="modalTitle"
                class="card-title mb-3 text-align-center"
              >
                Suas informações
              </h4>

              <form id="modalDescription">
                <div class="row pl-3">
                  <base-input
                    type="text"
                    label="Nome*"
                    v-model="user.nome"
                    @input="validaCampos()"
                    @change="validaCampos()"
                  ></base-input>
                </div>
                <div class="row pl-3">
                  <base-input
                    type="email"
                    label="Email*"
                    v-model="user.email"
                    @input="validaCampos()"
                    @change="validaCampos()"
                  ></base-input>
                </div>
                <div class="row pl-3">
                  <base-input
                    type="tel"
                    label="Telefone"
                    v-model="user.telefone"
                    @input="validaCampos()"
                    @change="validaCampos()"
                  ></base-input>
                </div>

                <div class="text-center mt-4">
                  <button
                    type="submit"
                    class="btn btn-success btn-fill float-right"
                    @click.prevent="submit"
                    :disabled="erroValidacao"
                  >
                    Enviar
                  </button>
                  <button
                    @click.prevent
                    class="btn btn-danger btn-fill float-left"
                    @click="close"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>
  </transition>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import SolucoesServices from 'src/services/solucoes';
import _ from 'lodash';
import { validateEmail } from '../../utils';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card
  },
  props: {
    tipoSolucao: Number
  },
  data() {
    return {
      notifications: {
        topCenter: false
      },
      simple: '',
      name: 'modal',
      user: {
        nome: '',
        email: '',
        telefone: ''
      },
      erroValidacao: true
    };
  },
  methods: {
    submit() {
      const { user, tipoSolucao } = this;
      if (!validateEmail(user.email)) {
        this.notifyVue(
          'top',
          'center',
          'danger',
          'Digite um e-mail válido',
          'fa fa-exclamation-triangle'
        );
        return;
      }

      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR,
        zIndex: 9999
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Solicitação realizada com sucesso',
          'fa fa-check'
        );
        this.user = {
          nome: '',
          email: '',
          telefone: ''
        };
        this.close();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      SolucoesServices.solicitar({ user, tipoSolucao })
        .then(sucessCallback)
        .catch(errorCallback);
    },
    close() {
      this.$emit('close');
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    validaCampos() {
      if (
        this.user.nome == '' ||
        !this.user.nome ||
        this.user.email == '' ||
        !this.user.email
      ) {
        this.erroValidacao = true;
      } else this.erroValidacao = false;
    }
  }
};
</script>
<style scoped>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

#modalDescription {
  width: 350px;
}

.modal-body {
  position: relative;
}

#profile-photo {
  width: 7em;
  height: 7em;
}

#upload_widget {
  max-height: 30px;
}

.form-group {
  width: 100%;
}
</style>
